var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"max-width":"900px"},attrs:{"fluid":""}},[_c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('router-view',{attrs:{"profile":_vm.profile,"user":_vm.user}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }